export interface Message {
  dialogId: string;
  dialog: IDialog[];
  isFeatureActive: boolean;
  isAIActive: boolean;
}

export interface IDialog {
  id?: number;
  role?: string;
  content?: string;
  message?: string;
}

// export interface InitialResponse {
//   id: string;
//   greeting: string;
// }

export enum CHAT_ROLES {
  BOT = 'da-chatbot-message--bot',
  USER = 'da-chatbot-message--user',
}

export interface ChatMessage {
  role: CHAT_ROLES;
  text?: string;
}
